import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    border: `1px solid ${zeplinColor.Neutral5}`,
    borderRadius: '14px',
    gap: '12px',
    padding: '16px',
  },
  header: { display: 'flex', gap: '12px', width: '100%', alignItems: 'center' },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
  },
  clientAvatar: { width: '50px', height: '50px' },

  nameAndRelationship: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  name: {
    color: zeplinColor.BasicBlack,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  title: {
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    whiteSpace: 'nowrap',
    maxWidth: '80%',
  },
  chip: {
    '&.MuiChip-root': {
      padding: '4px 8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: { xs: '18px', xl: '22px' },
      borderRadius: '50px',
    },
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  chipLabel: { display: 'flex', alignItems: 'center' },
  infoRow: { display: 'flex', gap: '8px', alignItems: 'center' },
  email: {
    color: zeplinColor.Brand1,
    textDecoration: 'none',
  },
  divider: { borderColor: zeplinColor.Neutral5 },
};
